// Feed and DM thumbnails are served at a smaller rendition than the full-screen
// viewer, which used to be covered by rendering a second hidden <img> at full size
// for every image on screen — doubling image bytes for images most users never open.
// Instead, warm the full-size rendition on first touch: the fetch overlaps the
// round-trip that opens the modal, so the image is usually cached by the time it shows.
const ImagePrefetch = {
    mounted() {
        this.prefetched = false;

        this.prefetch = () => {
            if (this.prefetched) return;
            this.prefetched = true;

            const url = this.el.dataset.prefetchUrl;
            if (url) new Image().src = url;
        };

        this.el.addEventListener("pointerdown", this.prefetch, { passive: true });
    },

    destroyed() {
        this.el.removeEventListener("pointerdown", this.prefetch);
    },
};

export default ImagePrefetch;
